import { Row } from 'antd';
import styled from 'styled-components';

export const ProjectLibraryContainer = styled(Row)`
    min-width: 1224px;
    .project-name-wrapper {
        max-width: 400px;
    }
`;
